<template>
    <b-modal id="modal-booking-appointment" ref="modal-booking-appointment" :hide-footer="isHideMdFooter" :title="modalFormAction + ' ' + title" ok-title="Submit" cancel-title="Close" @cancel="resetFormData" @close="resetFormData" @ok.prevent="submitBookingForm">
        <form @submit.prevent="handleSubmit(submitBookingForm)">
            <b-row>
                <b-form-group class="col-12"
                label="Patient:"
                >
                    <h4>{{patientName}} [{{ patientNo }}]</h4>
                </b-form-group>
            </b-row>
            <b-row>
                <b-form-group class="col-12"
                label="Title:"
                label-for="appointment-title"
                >
                    <b-form-input v-model="formData.title" type="text" name="appointment-title" id="appointment-title" placeholder="Title" :disabled="isHideMdFooter" required></b-form-input>
                </b-form-group>
            </b-row>
            <b-row>
                <b-form-group label="Note" label-for="note" class="col-12">
                    <b-form-textarea id="note" v-model="formData.note" rows="3"></b-form-textarea>
                </b-form-group>
            </b-row>
            <b-row>
                <b-form-group class="col-12"
                label="Start Date:"
                label-for="date-from"
                >
                    <b-form-input v-model="formData.date_from" type="datetime-local" :max="formData.date_to" name="date-from" id="date-from" placeholder="Start Date" :disabled="isHideMdFooter" required></b-form-input>
                </b-form-group>
            </b-row>
            <b-row>
                <b-form-group class="col-12"
                label="End Date:"
                label-for="date-to"
                >
                    <b-form-input v-model="formData.date_to" :min="formData.date_from" type="datetime-local" name="date-to" id="date-to" placeholder="End Date" :disabled="isHideMdFooter" required></b-form-input>
                </b-form-group>
            </b-row>
        </form>
    </b-modal>
</template>
<script>
import booking from '../../../../services/booking'
export default {
    name: 'BookingAppointmentComponent',
    props: {
        patient: Object,
        nonExistingPatient: Object,
        classificationList: Array,
        modalFormAction: String
    },
    data () {
        return {
            showPatient: false,
            isHideMdFooter: false,
            title: 'Booking Appointment',
            patientList: [],
            formData: {
                id: '',
                classification_id: 1, // Patient's Appointment
                patient_id: '',
                title: '',
                note: '',
                date_from: '',
                date_to: '',
                first_name: '', // this will be use if there is no patient record
                last_name: '', // this will be use if there is no patient record
                dob: '', // this will be use if there is no patient record
                contact_no: '' // this will be use if there is no patient record
            },
            patientName: '',
            patientNo: ''
        }
    },
    watch: {
        patient: {
            handler (newPatient) {
                if (newPatient) {
                    console.log('newPatient')
                    this.setPatient({ ...newPatient }) // ensures reactivity trigger
                }
            },
            deep: true,
            immediate: true
        },
        nonExistingPatient: {
            handler (newNonPatient) {
                // Only use nonPatient if NO patient is selected
                if (!this.patient && newNonPatient) {
                    this.setNonExistingPatient({ ...newNonPatient })
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        selectClassification () {
            var classData = this.classificationList.filter(d => {
                return this.formData.classification_id === d?.id
            })
            if (classData.length) {
                this.showPatient = classData[classData.length - 1]?.isRequiredPatient === 'Y'
            }
        },
        resetFormData () {
            this.formData.id = ''
            this.formData.classification_id = 1
            this.formData.patient_id = ''
            this.formData.title = ''
            this.formData.note = ''
            this.formData.date_from = ''
            this.formData.date_to = ''
            this.formData.first_name = '' // this will be use if there is no patient record
            this.formData.last_name = '' // this will be use if there is no patient record
            this.formData.dob = '' // this will be use if there is no patient record
            this.formData.contact_no = '' // this will be use if there is no patient record
        },
        submitBookingForm () {
            if (this.modalFormAction === 'Create') {
                console.log('formData', this.formData)
                booking
                    .createBooking(this.formData)
                    .then(({ data }) => {
                        if (data?.success) {
                            this.resetFormData()
                            this.$bvModal.hide('modal-booking-appointment')
                            this.$emit('triggerBooking')
                        }
                        this.$swal(data?.message)
                    })
                    .catch(err => console.log(err))
            } else {
                booking
                    .updateBooking(this.formData, this.formData.id)
                    .then(({ data }) => {
                        if (data?.success) {
                            this.resetFormData()
                            this.$bvModal.hide('modal-booking-appointment')
                            this.$emit('triggerBooking')
                        }
                        this.$swal(data?.message)
                    })
                    .catch(err => console.log(err))
            }
        },
        setPatient (patientData) {
            this.formData.patient_id = patientData?.id
            this.patientName = `${patientData.first_name} ${patientData.last_name}`
            this.patientNo = patientData.patient_no
             // CLEAR non-patient fields
            this.formData.first_name = ''
            this.formData.last_name = ''
            this.formData.dob = ''
            this.formData.contact_no = ''
        },
        clearPatient () {
            this.formData.patient_id = ''
            this.patientName = ''
            this.patientNo = ''
        },
        setNonExistingPatient (data) {
            console.log(data)
            this.formData.patient_id = ''
            this.patientName = `${data.firstName} ${data.lastName} (Non-Patient)`
            this.patientNo = 'N/A'
            // Fill non-patient fields since patient_id is empty
            this.formData.first_name = data.firstName || ''
            this.formData.last_name = data.lastName || ''
            this.formData.dob = data.birthDate || ''
            this.formData.contact_no = data.contactNumber || ''
        }
    }
}
</script>
